/**
 * Progress state of a lesson for a single target student.
 * Mirrors the backend `LessonProgressStatus` enum, which serializes numerically.
 */
export var LessonProgressStatus;
(function (LessonProgressStatus) {
    LessonProgressStatus[LessonProgressStatus["complete"] = 0] = "complete";
    LessonProgressStatus[LessonProgressStatus["completePendingApproval"] = 1] = "completePendingApproval";
    LessonProgressStatus[LessonProgressStatus["skipped"] = 2] = "skipped";
})(LessonProgressStatus || (LessonProgressStatus = {}));
/**
 * Why a skip cannot proceed. Mirrors the backend `SkipLessonRestrictionReason` enum, which serializes numerically,
 * so the ordinals must match the server exactly and never be reordered. Ordinals 0, 1 and 2 are section-wide; 3-7 are
 * per-student individual-flow reasons; 8 is a per-student reason that only skips the affected lessons.
 */
export var SkipLessonRestrictionReason;
(function (SkipLessonRestrictionReason) {
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["insufficientPermission"] = 0] = "insufficientPermission";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["studentsFromMultipleSections"] = 1] = "studentsFromMultipleSections";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["sectionNotStarted"] = 2] = "sectionNotStarted";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["identifierNotResolved"] = 3] = "identifierNotResolved";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["notEnrolledInSection"] = 4] = "notEnrolledInSection";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["enrolledInDifferentSection"] = 5] = "enrolledInDifferentSection";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["enrollmentNotYetStarted"] = 6] = "enrollmentNotYetStarted";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["noLongerActiveInSection"] = 7] = "noLongerActiveInSection";
    SkipLessonRestrictionReason[SkipLessonRestrictionReason["submittedAssessments"] = 8] = "submittedAssessments";
})(SkipLessonRestrictionReason || (SkipLessonRestrictionReason = {}));
